export const GET_LOG_SUMMARY_BLOB_METRIC_DATA = 'GET_LOG_SUMMARY_BLOB_METRIC_DATA';
export const GET_LOG_DETAIL_BLOB_METRIC_DATA = 'GET_LOG_DETAIL_BLOB_METRIC_DATA';
export const GET_EXCEPTION_SUMMARY_BLOB_METRIC_DATA = 'GET_EXCEPTION_SUMMARY_BLOB_METRIC_DATA';
export const GET_EXCEPTION_DETAIL_BLOB_METRIC_DATA = 'GET_EXCEPTION_DETAIL_BLOB_METRIC_DATA';
export const RESET_LOG_EXCEPTION_DETAIL_METRIC_DATA = 'RESET_LOG_EXCEPTION_DETAIL_METRIC_DATA';
export const SET_EXCEPTION_DETAIL_BLOB_METRIC_DATA = 'SET_EXCEPTION_DETAIL_BLOB_METRIC_DATA';
export const SET_LOG_DETAIL_BLOB_METRIC_DATA = 'SET_LOG_DETAIL_BLOB_METRIC_DATA';
export const SET_LOG_SUMMARY_BLOB_METRIC_DATA = 'SET_LOG_SUMMARY_BLOB_METRIC_DATA';
export const SET_EXCEPTION_SUMMARY_BLOB_METRIC_DATA = 'SET_EXCEPTION_SUMMARY_BLOB_METRIC_DATA';
